import React from 'react';
import { Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import StatusChart from './charts/StatusChart';
import '../styles/css/weekStatus.css';
import basic_lock from '../static/basic_lock.svg';
import complete from '../static/img_46.svg';
import { jsUcfirst } from '../util/utils';
import { trackEvent } from '../util/tracking';

function dayImage(chapterNumber, category, details) {
  const memberChapterId = details ? details.mb_ch_id : '';
  const isCompleted = details && details[category];
  const linkUrl =
    '/dashboard/' + chapterNumber + '/' + category + '/' + memberChapterId;

  if (isCompleted) {
    return (
      <Link
        to={linkUrl}
        onClick={() => {
          trackEvent(
            'DASHBOARD',
            'Click Complete Day',
            'week' + chapterNumber + '/' + category
          );
        }}
      >
        <input
          className='mini_circle complete'
          type='image'
          src={complete}
          alt='complete'
        />
      </Link>
    );
  } else {
    return (
      <Image
        className='mini_circle lock'
        src={basic_lock}
        alt='basic_lock'
        circle
      />
    );
  }
}

function lineStyle(isCompleted) {
  return isCompleted ? 'complete' : 'ongoing';
}

const ChapterStatus = ({ details, chapterNumber }) => {
  const completedCount = details
    ? details.dialog + details.pattern + details.vocabulary + details.quiz
    : 0;
  const categories = ['dialog', 'pattern', 'vocabulary', 'quiz'];

  return (
    <Row className='text-center'>
      <Col style={{ width: 'auto', display: 'inline-block' }}>
        <StatusChart completedCount={completedCount} totalCount={4} />
        {categories.map(category => (
          <div
            className={
              'assignment ' +
              lineStyle(details && details[category])
            }
            key={category}
          >
            <div className='line ' />
            <div className='form-group'>
              {dayImage(chapterNumber, category, details)}
              <label>{jsUcfirst(category)}</label>
            </div>
          </div>
        ))}
      </Col>
    </Row>
  );
};

export default ChapterStatus;



// WEBPACK FOOTER //
// ./src/components/ChapterStatus.js